import { Inject, ModelEvents, Singleton } from '@denishussar/html5-game-engine';
import { GameModel } from '../../Models/Game/GameModel';
import { BonusLogic } from './BonusLogic';
import { TaskType } from '../../Models/Game/TaskModel';
import { GameLogic } from '../GameLogic';
import { BonusTypeEnum } from '../../Models/Game/BonusModel';

import BonusContants from '../../Constants/BonusContants';

@Singleton
export class BonusEraserLogic extends BonusLogic {
    constructor(
        @Inject private _model: GameModel,
        @Inject private _modelEvents: ModelEvents
    ) {
        super();

        this._config = BonusContants.find(o => o.type === BonusTypeEnum.eraser);
    }

    public apply(gameLogic: GameLogic): void {
        super.apply(gameLogic);

        const count = this._config.props.eraseCount;

        this._gameLogic
            .getActiveTasks()
            .where(o => o.type === TaskType.Regular)
            .orderBy(o => o.time)
            .take(count)
            .forEach(o => {
                o.active = false;
                o.timeRunning = false;

                this._modelEvents.dispatch(
                    this._model,
                    'miniGameComplete',
                    o.miniGameType
                );
                this._modelEvents.dispatch(
                    this._model,
                    'removeTask',
                    o.miniGameType
                );

                this._gameLogic.pushTask(true, 1, o);
            });
    }

    public cancel(): void {
        super.cancel();
    }

    public destroy(): void {
        super.destroy();
    }

    public update(frameTime): void {}
}
